<script setup lang="ts">
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/landingPage/ui/card";

import { Badge } from "@/components/landingPage/ui/badge";

enum ProService {
  YES = 1,
  NO = 0,
}

interface ServiceProps {
  title: string;
  pro: ProService;
  description: string;
}

const serviceList: ServiceProps[] = [
  {
    title: "👩‍🎓 Parcours Jeune Accompagné",
    description:
      "Tableau de bord personnalisé, mini-jeux ludiques, création d'avatar, recherche de stages et apprentissages avec recommandations IA.",
    pro: 0,
  },
  {
    title: "👨‍🏫 Parcours Accompagnateur",
    description:
      "Suivi des jeunes, analyse de données IA, messagerie sécurisée, création d'ateliers interactifs et gestion des séances d'accompagnement.",
    pro: 0,
  },
  {
    title: "🏢 Portail Entreprise",
    description:
      "Publication d'offres inclusives, découverte de profils talents, formation à la neurodiversité et suivi d'intégration post-recrutement.",
    pro: 1,
  },
];
</script>

<template>
  <section
    id="services"
    class="container mx-auto py-24 sm:py-32"
  >
    <h2 class="text-lg text-[#ff9500] text-center mb-2 tracking-wider">
      Parcours Utilisateurs
    </h2>

    <h2 class="text-3xl md:text-4xl text-center font-bold mb-4">
      Trois parcours pour un écosystème inclusif
    </h2>
    <h3 class="md:w-1/2 mx-auto text-xl text-center text-muted-foreground mb-8">
      La plateforme s'adresse aux jeunes neurodivergents, aux accompagnateurs 
      (parents, enseignants, éducateurs) et aux entreprises inclusives.
    </h3>

    <div
      class="grid sm:grid-cols-1 lg:grid-cols-3 gap-4 w-full mx-auto"
    >
      <div
        v-for="{ title, description, pro } in serviceList"
        :key="title"
      >
        <Card class="bg-muted/60 dark:bg-card h-full relative">
          <CardHeader>
            <CardTitle>{{ title }}</CardTitle>
            <CardDescription>{{ description }}</CardDescription>
          </CardHeader>
          <Badge
            v-if="pro === ProService.YES"
            variant="secondary"
            class="absolute -top-2 -right-3"
            >Inclusif</Badge
          >
        </Card>
      </div>
    </div>
  </section>
</template>
